const SeachIcon = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M11.9878 12.8713C9.77927 14.6402 6.54641 14.501 4.49909 12.4537C2.30239 10.257 2.30239 6.69542 4.49909 4.49872C6.69579 2.30202 10.2573 2.30202 12.454 4.49872C14.5014 6.54604 14.6406 9.77889 12.8717 11.9875L17.1681 16.2838C17.4121 16.5279 17.4121 16.9236 17.1681 17.1677C16.924 17.4118 16.5283 17.4118 16.2842 17.1677L11.9878 12.8713ZM5.38297 11.5698C3.67443 9.86124 3.67443 7.09115 5.38297 5.3826C7.09151 3.67406 9.86161 3.67406 11.5702 5.3826C13.2774 7.08989 13.2787 9.85718 11.5739 11.566C11.5727 11.5673 11.5714 11.5685 11.5701 11.5698C11.5689 11.571 11.5676 11.5723 11.5664 11.5735C9.85755 13.2783 7.09026 13.2771 5.38297 11.5698Z'
				fill='#262626'
			/>
		</svg>
	);
};

export default SeachIcon;
